/* Slide-out cart drawer for The Panel Hub (Empire).
   - Opens on header cart-icon click and automatically after add-to-cart.
   - Refreshes via the Shopify Section Rendering API (no full reload).
   - Add-to-cart is left to Empire's own AJAX; we detect the header badge change
     to auto-open, which avoids double-adds and variant-id breakage. */
(function () {
  "use strict";

  var SECTION_ID = "cart-drawer";
  var busy = false;
  var internalOp = false;
  var lastCount = null;
  var lastFocus = null;

  function root() {
    return document.querySelector("[data-cart-drawer]");
  }

  function isOpen() {
    var el = root();
    return !!el && el.classList.contains("is-open");
  }

  function open() {
    var el = root();
    if (!el || el.hasAttribute("data-drawer-disabled")) return;
    lastFocus = document.activeElement;
    el.classList.add("is-open");
    document.body.classList.add("cart-drawer-open");
    var panel = el.querySelector(".cart-drawer__panel");
    if (panel) panel.focus();
    document.dispatchEvent(new CustomEvent("cart-drawer:open"));
    setupCreditAccordion();
  }

  function close() {
    var el = root();
    if (!el) return;
    el.classList.remove("is-open");
    document.body.classList.remove("cart-drawer-open");
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    document.dispatchEvent(new CustomEvent("cart-drawer:close"));
  }

  function readHeaderCount() {
    var el = document.querySelector("[data-header-cart-count]");
    if (!el) return 0;
    var v = parseInt(el.getAttribute("data-header-cart-count"), 10);
    return isNaN(v) ? 0 : v;
  }

  function updateBadge(count) {
    document.querySelectorAll("[data-header-cart-count]").forEach(function (el) {
      el.setAttribute("data-header-cart-count", count > 0 ? count : "");
      el.classList.toggle("visible", count > 0);
    });
    lastCount = count;
  }

  function refresh() {
    var el = root();
    if (el) el.classList.add("cart-drawer--loading");
    return fetch("/?sections=" + SECTION_ID, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (html == null) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("[data-cart-drawer]");
        var current = root();
        if (!fresh || !current) return;

        var freshPanel = fresh.querySelector(".cart-drawer__panel");
        var curPanel = current.querySelector(".cart-drawer__panel");

        // Surgical update: never replace the panel, so the app-injected store-credit
        // node (a panel child between body and footer) and its observer survive.
        if (freshPanel && curPanel) {
          var freshBody = freshPanel.querySelector("[data-cart-drawer-body]");
          var curBody = curPanel.querySelector("[data-cart-drawer-body]");
          if (freshBody && curBody) curBody.innerHTML = freshBody.innerHTML;

          var freshFs = freshPanel.querySelector(".cart-drawer__freeship");
          var curFs = curPanel.querySelector(".cart-drawer__freeship");
          if (freshFs && curFs) curFs.innerHTML = freshFs.innerHTML;
          else if (freshFs && !curFs && curBody) curPanel.insertBefore(freshFs.cloneNode(true), curBody);
          else if (!freshFs && curFs) curFs.parentNode.removeChild(curFs);

          var freshFooter = freshPanel.querySelector(".cart-drawer__footer");
          var curFooter = curPanel.querySelector(".cart-drawer__footer");
          if (freshFooter && curFooter) {
            var fNum = freshFooter.querySelector(".cart-drawer__subtotal-number");
            var cNum = curFooter.querySelector(".cart-drawer__subtotal-number");
            if (fNum && cNum) cNum.innerHTML = fNum.innerHTML;
            var fSub = freshFooter.querySelector(".cart-footer__subtotal");
            var cSub = curFooter.querySelector(".cart-footer__subtotal");
            if (fSub && cSub) cSub.innerHTML = fSub.innerHTML;
            curFooter.style.display = "";
          } else if (curFooter && !freshFooter) {
            curFooter.style.display = "none";
          } else if (freshFooter && !curFooter) {
            curPanel.appendChild(freshFooter.cloneNode(true));
          }
        } else {
          // Fallback (structure mismatch): full swap, rescuing the store-credit node.
          var credit = current.querySelector(".credit-redeem-drawer-wrap");
          current.innerHTML = fresh.innerHTML;
          var p2 = current.querySelector(".cart-drawer__panel");
          var f2 = p2 ? p2.querySelector(".cart-drawer__footer") : null;
          if (credit && p2) { if (f2) p2.insertBefore(credit, f2); else p2.appendChild(credit); }
        }

        var count = parseInt(fresh.getAttribute("data-cart-count") || "0", 10);
        if (isNaN(count)) count = 0;
        current.setAttribute("data-cart-count", count);
        var freshCount = fresh.querySelector("[data-cart-drawer-count]");
        var curCount = current.querySelector("[data-cart-drawer-count]");
        if (freshCount && curCount) curCount.textContent = freshCount.textContent;
        updateBadge(count);
        document.dispatchEvent(new CustomEvent("cart-drawer:refreshed"));
      })
      .catch(function () {})
      .then(function () {
        var e2 = root();
        if (e2) e2.classList.remove("cart-drawer--loading");
      });
  }

  function changeLine(line, quantity) {
    if (busy || !line) return;
    busy = true;
    internalOp = true;
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        setTimeout(function () { internalOp = false; }, 60);
      });
  }

  /* ---- click delegation ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-cart-drawer-toggle]");
    if (toggle) {
      e.preventDefault();
      open();
      refresh();
      return;
    }

    if (e.target.closest("[data-cart-drawer-close]") || e.target.closest("[data-cart-drawer-overlay]")) {
      e.preventDefault();
      close();
      return;
    }

    var inDrawer = e.target.closest("[data-cart-drawer]");
    if (!inDrawer) return;

    var removeBtn = e.target.closest("[data-cartitem-remove]");
    if (removeBtn) {
      e.preventDefault();
      var li = removeBtn.closest(".cart-drawer-item");
      if (li) li.classList.add("is-removing");
      var rLine = parseInt(removeBtn.getAttribute("data-line"), 10);
      changeLine(rLine, 0);
      return;
    }

    var qBtn = e.target.closest("[data-drawer-qty-plus], [data-drawer-qty-minus]");
    if (qBtn) {
      e.preventDefault();
      var wrap = qBtn.closest("[data-drawer-qty]");
      var input = wrap && wrap.querySelector("[data-drawer-qty-input]");
      var itemEl = qBtn.closest(".cart-drawer-item");
      if (!input || !itemEl) return;
      var step = parseInt(input.getAttribute("step"), 10) || 1;
      var cur = parseInt(input.value, 10) || 0;
      var next = qBtn.hasAttribute("data-drawer-qty-plus") ? cur + step : cur - step;
      if (next < 0) next = 0;
      input.value = next;
      changeLine(parseInt(itemEl.getAttribute("data-line"), 10), next);
      return;
    }
  });

  /* ---- typed quantity ---- */
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-drawer] [data-drawer-qty-input]");
    if (!input) return;
    var itemEl = input.closest(".cart-drawer-item");
    if (!itemEl) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeLine(parseInt(itemEl.getAttribute("data-line"), 10), qty);
  });

  /* ---- Esc to close ---- */
  document.addEventListener("keydown", function (e) {
    if ((e.key === "Escape" || e.key === "Esc") && isOpen()) close();
  });

  /* ---- auto-open on add-to-cart: watch the header badge ---- */
  function watchBadge() {
    lastCount = readHeaderCount();
    var scheduled = false;
    function evaluate() {
      scheduled = false;
      var count = readHeaderCount();
      if (count === lastCount) return;
      var increased = count > lastCount;
      lastCount = count;
      if (internalOp) return; // our own change already refreshed the drawer
      refresh();
      if (increased) open();
    }
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(evaluate);
    });
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["data-header-cart-count"]
    });
  }

  function setupCreditAccordion() {
    var cards = document.querySelectorAll("[data-cart-drawer] .credit-redeem__card:not([data-cd-accordion])");
    Array.prototype.forEach.call(cards, function (card) {
      var header = card.querySelector(".credit-redeem__header");
      if (!header) return;
      card.setAttribute("data-cd-accordion", "1");
      card.classList.add("is-collapsed");
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cd-credit-toggle";
      btn.setAttribute("aria-label", "Toggle store credit");
      btn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 6l4.5 4.5L12.5 6"></path></svg>';
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        card.classList.toggle("is-collapsed");
      });
      header.appendChild(btn);
    });
  }

  function init() {
    var el = root();
    if (el && !el.hasAttribute("data-drawer-disabled")) {
      document.documentElement.classList.add("cart-drawer-enabled");
    }
    watchBadge();

    var creditScheduled = false;
    function scheduleCredit() {
      if (creditScheduled) return;
      creditScheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        creditScheduled = false;
        setupCreditAccordion();
      });
    }
    if (el) new MutationObserver(scheduleCredit).observe(el, { childList: true, subtree: true });
    setupCreditAccordion();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.CartDrawer = { open: open, close: close, refresh: refresh };
})();
